/*
 * Posture sticky CTA.
 *
 * Shows the bottom bar once the shopper has scrolled past the hero, and hides it
 * again whenever a "blocker" section is on screen (the hero and the offer block
 * already carry the same buy button, so repeating it there is just noise).
 *
 * IntersectionObserver only — no scroll listeners, so nothing runs on the main
 * thread during scroll.
 */
(() => {
  'use strict';

  const VISIBLE = 'is-visible';

  const init = (root) => {
    if (!root || root.dataset.pstStickyInit === 'true') return;
    root.dataset.pstStickyInit = 'true';

    // Reveal it now that JS is running; CSS keeps it transparent until visible.
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');

    const raw = root.dataset.pstHideSelectors || '';
    const blockers = [];
    raw.split(',').forEach((sel) => {
      const s = sel.trim();
      if (!s) return;
      try {
        document.querySelectorAll(s).forEach((el) => {
          if (el && !blockers.includes(el)) blockers.push(el);
        });
      } catch (e) {
        /* invalid selector — skip */
      }
    });

    // Nothing to hide behind: just show it.
    if (!blockers.length || !('IntersectionObserver' in window)) {
      root.classList.add(VISIBLE);
      return;
    }

    const onScreen = new Set();
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) onScreen.add(entry.target);
          else onScreen.delete(entry.target);
        });
        root.classList.toggle(VISIBLE, onScreen.size === 0);
      },
      { threshold: 0 }
    );
    blockers.forEach((el) => io.observe(el));
  };

  const initAll = () => document.querySelectorAll('[data-pst-sticky]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-init when the section is reloaded.
  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target.querySelector ? e.target.querySelector('[data-pst-sticky]') : null;
    if (el) init(el);
  });
})();
